// extracted by mini-css-extract-plugin
export var label = "_l1-2";
export var slideContainer = "_l1-0";
export var slider = "_l1-1";